import React, { useEffect } from 'react'
import Heading from '../../../../components/Heading'
import FontCard from '../FontCard/FontCard'
import { Font } from '../../../../types/Font'
import Loader from '../../../../components/Loader'
import cx from 'classnames'
import styles from './FontList.module.css'
import { useTranslation } from 'react-i18next'
import { useFetchData } from '../../../../hooks/useFetchData'
import { ApiRoutes } from '../../../../services/ApiService'
import CreateFontCard from '../CreateFontCard/CreateFontCard'

const FontList: React.FC = () => {
    const { t } = useTranslation('settings')
    const {
        data: fonts,
        isLoading,
        fetch,
    } = useFetchData<Font>(ApiRoutes.FONTS)

    useEffect(() => {
        fetch()
    }, [fetch])

    return (
        <>
            <Heading level={4} classes={'zr-my-4'}>
                {t('fonts.sub_heading')}
            </Heading>
            {!isLoading && (
                <div className={cx(styles['font-list'])}>
                    <CreateFontCard onCreate={() => fetch()} fonts={fonts} />
                    {fonts
                        .sort((a, b) => {
                            if (a.name < b.name) return -1
                            else return 1
                        })
                        .map((font: Font) => {
                            return (
                                <FontCard
                                    key={font.id}
                                    font={font}
                                    fonts={fonts}
                                    onEdit={() => fetch()}
                                    onDelete={() => fetch()}
                                />
                            )
                        })}
                </div>
            )}
            {isLoading && (
                <div className={cx(styles['loading-wrapper'])}>
                    <Loader isLoading={isLoading} size={'m'} />
                </div>
            )}
        </>
    )
}

export default FontList
